import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/admin/AdminLayout';
import { getUser } from '../../utils/auth';
import api from '../../utils/api';
import './DashboardPage.css';

const DashboardPage = () => {
  const user = getUser();
  const [stats, setStats] = useState({
    totalBookings: 0,
    pendingBookings: 0,
    preparationBookings: 0,
    totalTherapists: 0,
    totalRevenue: 0,
  });
  const [recentBookings, setRecentBookings] = useState([]);

  useEffect(() => {
    fetchDashboardData();
  }, []);

  const fetchDashboardData = async () => {
    try {
      const [bookingsRes, therapistsRes, paymentsRes] = await Promise.all([
        api.get('/bookings'),
        api.get('/therapists/admin'),
        api.get('/payments'),
      ]);

      const bookings = bookingsRes.data;
      const therapists = therapistsRes.data;
      const payments = paymentsRes.data;

      const pendingCount = bookings.filter(b => b.status === 'PENDING').length;
      const preparationCount = bookings.filter(b => b.inPreparation === true).length;
      const paidPayments = payments.filter(p => p.status === 'PAID');
      const totalRevenue = paidPayments.reduce((sum, p) => sum + p.amount, 0);

      setStats({
        totalBookings: bookings.length,
        pendingBookings: pendingCount,
        preparationBookings: preparationCount,
        totalTherapists: therapists.length,
        totalRevenue: totalRevenue,
      });

      setRecentBookings(bookings.slice(0, 5));
    } catch (error) {
      console.error('Failed to fetch dashboard data:', error);
    }
  };

  return (
    <AdminLayout>
      <div className="dashboard-page">
        <h1 className="dashboard-title">Dashboard</h1>
        <p className="dashboard-welcome">Welcome back, {user?.name || 'Admin'}</p>

        <div className="dashboard-stats">
          <div className="stat-card">
            <div className="stat-icon">📋</div>
            <div className="stat-info">
              <span className="stat-value">{stats.totalBookings}</span>
              <span className="stat-label">Total Bookings</span>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">⏳</div>
            <div className="stat-info">
              <span className="stat-value">{stats.pendingBookings}</span>
              <span className="stat-label">Pending</span>
            </div>
          </div>
          <div className="stat-card stat-card-preparation">
            <div className="stat-icon">⚠️</div>
            <div className="stat-info">
              <span className="stat-value">{stats.preparationBookings}</span>
              <span className="stat-label">준비중</span>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">💆</div>
            <div className="stat-info">
              <span className="stat-value">{stats.totalTherapists}</span>
              <span className="stat-label">Therapists</span>
            </div>
          </div>
          <div className="stat-card">
            <div className="stat-icon">💰</div>
            <div className="stat-info">
              <span className="stat-value">{stats.totalRevenue.toLocaleString()} ฿</span>
              <span className="stat-label">Revenue</span>
            </div>
          </div>
        </div>

        {recentBookings.length > 0 && (
          <div className="dashboard-recent">
            <h2>Recent Bookings</h2>
            <div className="recent-table-wrapper">
              <table className="recent-table">
                <thead>
                  <tr>
                    <th>Code</th>
                    <th>Location</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {recentBookings.map((booking) => (
                    <tr key={booking.id}>
                      <td>
                        <span className="booking-code-cell">
                          <strong>{booking.bookingCode}</strong>
                          {booking.inPreparation && (
                            <span className="preparation-badge">준비중</span>
                          )}
                        </span>
                      </td>
                      <td>{booking.locationId}</td>
                      <td>{booking.bookingDate}</td>
                      <td>
                        <span className={`status-badge ${booking.status.toLowerCase()}`}>
                          {booking.status}
                        </span>
                      </td>
                      <td>{booking.price?.toLocaleString()} ฿</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
};

export default DashboardPage;
